module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/4.2-operation-procedure.2833e44d.png";